import type { Node } from '../../../services/goals';
import type { Goal } from './types';

export const transformToGoal = ({ id, key, name, state, url }: Node): Goal => ({
	id,
	key,
	name,
	url,
	state: {
		...state,
		score: state.score ?? undefined, // convert null to undefined
	},
});
